import React from "react";
import { Compass, Eye, Palette, Layers, BookOpen, Target } from "lucide-react";
import ServiceDetailTemplate from "@/pages/ServiceDetailTemplate";

const config = {
  testidPrefix: "bd",
  serviceNumber: "06",
  eyebrow: "Branding & Direction Artistique",
  title: "Branding &",
  titleAccent: "Direction Artistique",
  subtitle:
    "Une vision créative claire, cohérente et reconnaissable pour votre marque.",
  paragraphs: [
    "Le branding va bien au-delà d'un logo : c'est l'ensemble des perceptions, valeurs et émotions associées à votre marque.",
    "Chez <strong class='font-medium'>Brams Graphic</strong>, nous vous accompagnons stratégiquement dans la construction d'une identité visuelle forte et cohérente — de la définition de votre positionnement à la mise en œuvre de tous vos supports.",
    "La direction artistique garantit la continuité visuelle sur l'ensemble de votre communication : print, web, réseaux sociaux, packaging, signalétique.",
    "Notre objectif : faire de votre marque une expérience reconnaissable au premier regard, partout, par tous.",
  ],
  bullets: [
    { icon: Compass, title: "Stratégie de marque", desc: "Positionnement, valeurs, promesse, ton de voix — les fondations de votre identité." },
    { icon: Eye, title: "Univers visuel", desc: "Direction artistique, moodboard, atmosphère et style photographique." },
    { icon: Palette, title: "Système graphique", desc: "Palette, typographies, iconographie et règles d'utilisation cohérentes." },
    { icon: Layers, title: "Déclinaisons multi-supports", desc: "Application sur print, web, réseaux, packaging, signalétique et plus." },
    { icon: BookOpen, title: "Guide de marque", desc: "Document de référence pour garantir la cohérence sur tous les projets." },
    { icon: Target, title: "Accompagnement long terme", desc: "Suivi stratégique et créatif pour faire évoluer votre marque dans le temps." },
  ],
  realisations: [
    "Stratégies de positionnement",
    "Univers visuels complets",
    "Chartes graphiques détaillées",
    "Refontes d'identité",
    "Guides de marque",
    "Direction artistique de campagnes",
  ],
  mockupSrc:
    "https://customer-assets.emergentagent.com/job_brams-portfolio/artifacts/flybezwb_ChatGPT%20Image%2027%20juin%202026%2C%2000_24_13.png",
  mockupAlt: "Branding & Direction Artistique — identité BSG",
  badges: [
    { k: "Stratégie", v: "Sur-mesure" },
    { k: "Cohérence", v: "Globale" },
    { k: "Suivi", v: "Long terme" },
  ],
  ctaLabel: "Demander un devis",
  bottomLine: (
    <>
      Construisons votre <span style={{ color: "#E11D2E" }}>identité forte</span>.
    </>
  ),
};

export default function BrandingDirection() {
  return <ServiceDetailTemplate config={config} />;
}
